import { ref } from 'vue'

export function useFold () {
  const foldRef = ref(null)
  const isFold = ref(false)

  const handleFold = () => {
    isFold.value = !isFold.value
    nextTick(() => {
      if (isFold.value) {
        const h = foldRef.value.offsetHeight
        foldRef.value.style.height = h + 'px'
    
        foldRef.value.offsetHeight
        foldRef.value.style.height = 0
      } else {
        foldRef.value.style.height = 'auto'
        const h = foldRef.value.offsetHeight
        foldRef.value.style.height = 0
    
        foldRef.value.offsetHeight
        foldRef.value.style.height = h + 'px'
      }
    })
  }
  return {
    isFold,
    foldRef,
    handleFold
  }
}